import { isIsoDate } from "../is/isIsoDate.js";
function instanceOfIsoDateRange(object) {
  return Array.isArray(object) && object.length === 2 && object.every((n) => isIsoDate(n));
}
export {
  instanceOfIsoDateRange
};
